<template>
   <v-navigation-drawer
        :mini-variant.sync="mini"
        id="appDrawer"
        app
        fixed
        v-model="$store.state.app.navDrawer"
        width="270"
        class="drawer"
   >
      <div class="brand-container">
         <div class="brand-bar">
            <v-avatar class="mr-2 pa-2" size="45px">
               <img :src="companyLogo" height="40px" v-if="companyLogo" width="40px">
               <span class="white--text title" v-else>{{$util.initials(companyBrand.name)}}</span>
            </v-avatar>
            <div class="company-info">
               <p class="company-title">Empresa</p>
               <p class="company-name">{{companyBrand.name}}</p>
            </div>
         </div>
      </div>
      <vue-perfect-scrollbar :settings="scrollSettings" class="drawer-menu--scroll">
        <v-list dense class="menu-list">
            <p class="mb-2">Menu</p>
            <div class="menu-list-items" v-bind:key="i" v-for="(item, i) in uCan(menus)" v-on:click="item.items && item.items.length ? openMenu() : redirect(item.route)">
                <div class="menu-list-item-container">
                    <div class="menu-list-item">
                        <v-icon class="menu-list-item-icon">{{ item.icon }}</v-icon>
                        <p>{{ item.title }}</p>
                    </div>
                    <v-icon v-if="item.items && item.items.length">fas fa-chevron-down</v-icon>
                </div>
                <div class="sub-menu-list-items" v-if="item.items && item.items.length">
                    <p class="sub-menu-list-item" :key="i" v-for="(subitem, i) in uCan(item.items)" v-on:click="redirect(subitem.route)">{{ subitem.title }}</p>
                </div>
            </div>
        </v-list>
      </vue-perfect-scrollbar>
   </v-navigation-drawer>
</template>

<script>
import menu from '@/api/menu';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
    name: 'app-drawer',
    components: {
        VuePerfectScrollbar,
    },

    props: ['appName'],

    data: () => ({
        mini: false,
        drawer: false,
        menus: menu,
        scrollSettings: {
            maxScrollbarLength: 160
        }
    }),

    computed: {
        companyBrand () {
            return this.$store.state.company.brand;
        },
        companyLogo () {
            let logo = this.$store.state.company.brand.logo;
            let media;
            if (logo) {
                media = this.$config.imageUri(logo.name || logo, 'sqLogo');
            }

            return media;
        },
    },

    created () {
        console.log('APP DRW CREATE: ', menu);
        window.getApp.$on('APP_DRAWER_TOGGLED', () => {
            console.log('drawer toggled');
            this.$store.state.app.navDrawer = (!this.$store.state.app.navDrawer);
            // this.$emit('DrawerVisible', this.$store.state.app.navDrawer);
        });

        window.getApp.$on('APP_LOGOUT', () => {
            window.getApp.$off('APP_DRAWER_TOGGLED');

            setTimeout(() => {
                this.$store.state.app.navDrawer = false;
                // this.$emit('DrawerVisible', this.$store.state.app.navDrawer);
            }, 300);
        });
    },

    mounted () {
        if (window.innerWidth > 960) {
            setTimeout(() => { this.$store.state.app.navDrawer = true }, 550);
        }

    },

    methods: {
        genChildTarget (item, subItem) {
            if (subItem.href) return;
            if (subItem.component) {
                return {
                    name: subItem.component,
                };
            }
            return { name: `${item.group}/${(subItem.name)}` };
        },
        uCan (list) {
            let uCanList = [];

            list.forEach(l => {
                if (this.$uCan({ route: l.route })) {
                    uCanList.push(l);
                }
            });

            return uCanList;
        },
        
        redirect (to) {
            this.$router.push(to);
        },

        openMenu (element) {
            console.log(element);
        }
    },

};
</script>

<style scoped>
    p {
        margin: 0;
    }

    ::-webkit-scrollbar {
        display: none;
    }

   .drawer {
      background-color: #EFEFEF;
      z-index: 10000;
   }
   
   .menu-list {
      width: 100%;
      padding: 15px;
   }

   .menu-list > p {
      margin-left: 10px;
      font-weight: bold;
      color: #adadad;
   }

   .menu-list-items {
        width: 100%;
      padding: 15px;
      font-weight: bold;
      border-radius: 5px;
      color: #262626;
      user-select: none;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
   }

   .menu-list-items i {
      font-size: 18px;
      color: #adadad;
   }

   .menu-list-items:hover {
      background-color: #FFF;
      cursor: pointer;
   }

   .menu-list-items:hover .menu-list-item-icon {
      color: var(--primary-color);
   }

    .menu-list-item-container {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .sub-menu-list-items {
        width: 100%;
        margin-top: 15px;
        display: none;
        margin-left: 30px;
    }

    .sub-menu-list-item {
        width: 100%;
        padding: 10px;
        border-radius: 5px;
    }

    .sub-menu-list-item:hover {
        background-color: #EFEFEF;
    }

    .menu-list-items:hover .sub-menu-list-items {
        display: block;
    }

    .menu-list-item {
        display: flex;
        flex-direction: row;
    }

    .menu-list-item p {
        overflow: hidden;
        word-break: keep-all;
    }
   .menu-list-item-icon {
      font-size: 16px;
      width: 25px;
      margin-right: 10px;
      color: #adadad;
   }

   .brand-container {
      width: 100%;
      padding: 20px;
      padding-bottom: 0;
   }

   .brand-bar {
      background-color: #010efc0c;
      padding: 10px;
      border-radius: 5px;
      display: flex;
      flex-direction: row;
      align-items: center;
   }

   .company-title {
      font-size: 14px;
      color: #262626;
   }

   .company-name {
      font-size: 18px;
      font-weight: bold;
      line-height: 1;
      color: #262626;
   }
</style>


// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/layout/components/AppDrawer.vue